export default {
  generateToken: '/aisee/v1/manage/upload-filter', // 生成token
  analysisToken: '/aisee/v1/manage/feedbacks/list', // 获取token数据
  getGroupFields: '/aisee/v1/manage/groupFields', // 获取高级搜索过滤字段
  getFeedbackUserCount: '/aisee/v1/manage/feedbacksUserTotal', // 获取反馈人数
  getFeedbackListTotal: '/aisee/v1/manage/feedbacksTotal', // 获取反馈列表总数
  getFeedbackListV2Aisee: '/aisee/v1/manage/feedbacksV2', // 获取反馈列表
  getFeedbackReplyList: '/aisee/v1/manage/feedbackReplyList', // 获取当前用户回复的反馈列表
  getBusinessFeedbackListV2Aisee: '/aisee/v1/manage/businessFeedbacks', // 获取反馈列表(多源)
  getFixedFieldOptions: '/aisee/v1/manage/fixedFieldOptions', // 查询问题类型/状态/属性/网络/附件字段下拉列表选项
  getFeedbackWebDetailsAisee: '/aisee/v1/manage/feedbackWebDetails', // 获取反馈详细信息
  feedbackReplys: '/aisee/v1/manage/feedbackReplys', // 获取反馈回复信息
  getScoreConfig: '/aisee/v1/score/config', // 满意度配置
  withdrawReplyAisee: '/aisee/v1/manage/withdrawReply', // 撤回消息
  replyCountAisee: '/aisee/v1/manage/repliesTotal', // 反馈回复条数
  sendReplyAisee: '/aisee/v1/manage/sendReply', // 回复反馈信息
  sendRepliesAisee: '/aisee/v1/manage/sendReplies', // 批量回复反馈信息
  faqGroupList: '/aisee/v1/manage/faq/group/list', // 查询 Faq 分组列表
  getPluginListAisee: '/aisee/v1/plugin/list', // 反馈详情获取插件列表
  pluginArtificial: '/aisee/v1/plugin/artificial', // 单条执行插件
  getHistories: '/aisee/v1/manage/histories', // 获取变更历史
  seedFeedbackEdit: '/aisee/v1/manage/feedbackEdit', // 编辑反馈
  getFeedbackTypeEdit: '/aisee/v1/manage/feedbackTypeEdit', // 编辑反馈类型
  getLevelTree: '/aisee/v1/manage/levelTree', // 获取用户分类树
  getTags: '/aisee/v1/manage/tags', // 获取用户标签
  favorite: '/aisee/v1/manage/feedback/favorite', // 关注/取消关注
  getCustomList: '/aisee/v1/custom/field/list', // 获取自定义参数列表
  triggerInBatches: '/aisee/v1/plugin/triggerInBatches', // 插件批量执行
  triggerInBatchesResult: '/aisee/v1/plugin/triggerInBatchesResult', // 插件批量执行
  getBusinessTypes: '/aisee/v1/manage/businessTypes', // aisee字段来源
  getIssueListAisee: '/aisee/v1/manage/issues', // dcl2 获取问题列表
  getIssueDetail: '/aisee/v1/manage/issueDetail', // 获取问题详情
  delFeedbackRelate: '/aisee/v1/manage/issue/delFeedbackRelate', // 移除问题关联的反馈
  dimensionAttribution: '/aisee/v1/analysis/dimensionAttribution', // 归因分析
  getAiseeIssueHistory: '/aisee/v1/manage/issue/histories',
  addAiseeIssueComment: '/aisee/v1/manage/issue/newcomment',
  getAiseeIssueComments: '/aisee/v1/manage/issue/comments',
  saveIssue: '/aisee/v1/manage/issue/save', // 保存问题
  updateOncall: '/aisee/v1/manage/issueUpdateOncall', // 更新Oncall信息
  exportFeedbacks: '/aisee/v1/feedbacks/export', // 导出反馈
  getTagCountList: '/aisee/v1/intel/tag/count', // 获取列表页面的智能分类
  unbindTapd: '/aisee/v1/common/feedbackmgr/FeedbackUnbindTapd', // 解除绑定的 Tapd
  sendMessage: '/aisee/v1/manage/sendFeedbackRTXMsg', // 发送通知
  moveApp: '/aisee/v1/manage/feedback/moveapp', // 反馈修改项目
  submitfeedback: '/aisee/public/feedbacks', // 提交反馈
  importfeedback: '/aisee/v1/manage/import/feedback', // 批量提交反馈
  getFeedbackUserTrace: '/aisee/v1/manage/feedbackUserTrace', // 获取用户反馈轨迹
  genReply: '/aisee/v1/feedbackAnalysis/GetGenReply', // AI 回复信息
  getAppRegisterRecords: '/aisee/v1/product/QueryAppRegisterRecords', // 查询注册审核列表
  auditApp: '/aisee/v1/product/AuditApp', // 审批通过
  tpilotReportUsage: '/aisee/tpilot/autoreply/report_usage',
  /** ai报告流式接口 */
  aiCompontStream: '/tpilot/sse/report/component/stream',
  /** ai报告普通接口 */
  aiCompontGenerate: '/aisee/tpilot/report/component/generate',
  /** ai报告发送邮件 */
  reportEmail: '/aisee/tpilot/report/email',
  /** ai报告详情 */
  reportDetail: '/aisee/tpilot/report/info',
  getUserRecentFeedbacks: 'aisee/v1/manage/UserRecentFeedbacks', // 获取用户近期反馈数量
  getStatisticsDateData: '/aisee/v1/statistics/intelDateTags', // 获取日期分类统计数据
  createAnalyzeTask: '/aisee/tpilot/log/create_analyze_task', // 创建日志分析任务
  getAnalyzeTask: '/aisee/tpilot/log/get_analyze_task', // 获取日志分析任务内容
  checkCanDownload: '/aisee/tpilot/log/check_can_download', // 检测日志后台是否可下载
  logFilterView: '/aisee/tpilot/log/log_filter_view', // 日志过滤查看
  uploadFileToCos: '/aisee/tpilot/log/upload_file_to_cos', // 上传文件到 COS
  /** 附件上传历史 */
  getUploadFileHistory: '/aisee/tpilot/log/get_upload_file_history',
  /** 版本号筛选 */
  versionFilter: '/aisee/tpilot/version/filter',
  /** 引用场景日志分析搜索 */
  logScenConfigSearch: '/aisee/tpilot/log/log_scene_config',
  /** 引用场景日志分析新增 */
  logScenConfigAdd: '/aisee/tpilot/log/log_scene_config/add',
  /** 引用场景日志分析编辑 */
  logScenConfigUpdate: '/aisee/tpilot/log/log_scene_config/update',
  /** tpilot功能开关 */
  tpilotConfigSwitchs: '/aisee/tpilot/config/switchs',
  /** tpilot获取预设词 */
  getTpilotPresetQuestion: '/aisee/tpilot/log/get_preset_question',
  /** tpilot新增预设词 */
  addTpilotPresetQuestion: '/aisee/tpilot/log/add_preset_question',
  /** tpilot更新预设词 */
  updateTpilotPresetQuestion: '/aisee/tpilot/log/update_preset_question',
  /** tpilot删除预设词 */
  deleteTpilotPresetQuestion: '/aisee/tpilot/log/delete_preset_question',
  /** tpilot关键词总结 */
  tpilotClusterCummary: '/aisee/tpilot/cluster/topic/summary',
  /** 获取旧模型开关标签 */
  getOldModelTag: '/aisee/v1/class/legacy/switch',
  /** 设置旧模型开关标签 */
  setOldModelTag: '/aisee/v1/class/legacy/switch/set',
};
